/* 🤖 this file was generated by svg-to-ts */
export const matIconHomeRepairService: {
  name: 'home-repair-service';
  data: string;
} = {
  name: 'home-repair-service',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10h20V10c0-1.1-.9-2-2-2zM9 6h6v2H9V6zm11 12H4v-3h2v1h2v-1h8v1h2v-1h2v3zm-2-5v-1h-2v1H8v-1H6v1H4v-3h16v3h-2z"/></svg>`
};
